// Date Function
export function extractDate(isoString) {
  return isoString ? isoString.split("T")[0] : null;
}
